import { isString } from 'lodash';

import i18n from 'src/locales/i18n';

import { BusinessErrorCodes } from 'src/types/business-errors';

export const generateUnlinkConnectionErrorMessage = (e: any) => {

  if (e?.status === 403) {
    return i18n.t('exceptions.unauthorized');
  }

  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.InvalidConnectionStatus) {
      return i18n.t('admin-connections.api.unlink.invalid');
    }

    if (e?.data.error_code === BusinessErrorCodes.SubtenantConnectionCannotBeRemoved) {
      return i18n.t('admin-connections.api.unlink.subtenant_connection_cannot_be_removed');
    }
  }
  return i18n.t('admin-connections.api.unlink.default_error');
};

export const generateConnectionCreateErrorMessage = (e: any) => {

  if (e?.status === 403) {
    return i18n.t('exceptions.unauthorized');
  }

  if (e?.data?.feature_type) {
    return i18n.t(`admin-connections.api.errors.features.${e.data.feature_type}`);
  }

  if (isString(e?.data?.error_code)) {
    if ([BusinessErrorCodes.ConnectionRequestExists, BusinessErrorCodes.ActiveConnectionExists].includes(e?.data.error_code)) {
      return i18n.t('admin-connections.api.initiate.already_exists');
    }

    if ([BusinessErrorCodes.InvalidConnectionTarget].includes(e?.data.error_code)) {
      return i18n.t('admin-connections.api.initiate.invalid_target');
    }

    if (e?.data.error_code === BusinessErrorCodes.BadTenantOperation) {
      return i18n.t('admin-connections.api.initiate.company_email');
    }
  }

  return i18n.t('admin-connections.api.initiate.default_error');
};

